<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>保险列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->
            <el-form
                    :inline="true"
                    :model="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    autocomplete="on"
                    size="mini"
            >
                <el-form-item label="运输公司"  label-width="70px">
                <el-select
                        v-model="shop_id"
                        filterable
                        clearable
                        placeholder="请选择运输公司"
                  >
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="关键字"  label-width="70px">
                    <el-input v-model="searchForm.name"  placeholder="请输入车牌号/联系人电话" clearable type="text"></el-input>
                </el-form-item>



                <el-form-item>
                    <el-button  type="success" @click="searchSubmit()">搜索</el-button>
                    <!-- <el-button @click="searchRest()">重置</el-button> -->
                </el-form-item>


            </el-form>

            <!-- 表格 -->
            <el-table
                    ref="multipleTable"
                    :data="tableLoadData"
                    height="450"
                    stripe
                    border
                    size="mini"
            >
                <el-table-column
                        type="selection"
                        align="center"
                        width="60">
                </el-table-column>
                <el-table-column

                        label="车牌号"
                        width="105"
                        prop="plate_number"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column

                        label="保险名称"
                        width="105"
                        prop="product_name"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="保险金额"
                        width="105"
                        prop="price"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>

                <el-table-column
                        label="保险客服"
                        prop="loan_name"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="投保人"
                        width="120"
                        prop="shop_name"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        width="120"
                        label="被投保人"
                        prop="owner_name"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>
                <el-table-column
                        label="保险起期"
                        width="100"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.loan_time | dateFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="保险止期"
                        width="100"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.loan_time | dateFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="经办人"
                        width="105"
                        prop="op_name"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>


                <el-table-column
                        label="备注"
                        width="105"
                        prop="remark"
                        :show-overflow-tooltip='true'
                >
                </el-table-column>


                <el-table-column
                        label="操作"

                        width="130"
                >
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelCancel(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增编辑弹框 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
            <el-form :model="form" :rules="rules" ref="form" label-width="110px">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="日期" prop="name" size="small">
                            <el-input v-model="form.name" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="业务类别" prop="corporation" size="small">
                            <el-input v-model="form.corporation" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="经办人" size="small">
                            <el-input v-model="form.type" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车号" prop="credit_code" size="small">
                            <el-input v-model="form.credit_code" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="车主" prop="" size="small">
                            <el-input v-model="form.incorporation_date" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="金额" prop="" size="small">
                            <el-input v-model="form.registered_capital" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="单号" prop="" size="small">
                            <el-input v-model="form.bank_account" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item label="备注" size="small">
                            <el-input v-model="form.business_scope" type="textarea" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reset_dialogForm('form')">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="图片" :visible.sync="uploadDialog" width="300px" style="line-height: 0;">
            <img style="width: 100%;height: 100%" :src="uploadImg" alt="" />
        </el-dialog>


    </div>
</template>

<script>
    import eTable from "../common/eTable.vue";
    import moment from 'moment';    //日期时间转换
    import eInsurance from "../common/eInsurance";
    export default {
        name: "shipCompany",
        components: {
            eTable,
            eInsurance
        },
        props: {},
        data() {
            return {
                shopList:[],
                shop_id:'',
                isShowCar:false,
                // 搜索
                searchForm: {
                    name: '',
                    credit_code:''
                },
                searchRules: {
                    name: [
                        { required: true, message: "请输入公司名称", trigger: "blur" },
                    ],
                },
                // 表头
                tableHeadConfig: [
                    {
                        label: "ID",
                        field: "id"
                    },

                    {
                        label: "产品名称",
                        field: "name"
                    },
                    {
                        label: "产品分类",
                        columnType: "slot",
                        slotName: "categoryName"
                    },
                    {
                        label: "创建时间",
                        columnType: "slot",
                        slotName: "addTime"
                    },
                    {
                        label: "备注",
                        field: "remark"
                    },
                    {
                        label: "操作",
                        columnType: "slot",
                        slotName: "operation",
                        width: 200
                    }
                ],
                // 数据
                tableLoadData: [],
                limit: 10,
                page:1,// 当前页码
                total:0,//总条目数
                id: '',
                rules: {
                    name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                    corporation: [{ required: true, message: '请输入法人', trigger: 'blur' }],
                    credit_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
                },
                dialogFormVisible: false,
                title: '',
                form: {
                    name: '',
                    address: '',
                    credit_code: '',
                    composition: '',
                    business_scope: '',
                    incorporation_date: '',
                    corporation: '',
                    registered_capital: '',
                    certificate_no: '',
                    lifespan: '',
                    issue_date: '',
                    type: '',
                    duty_paragraph: '',
                    mobile: '',
                    bank: '',
                    bank_account: '',
                },
                uploadImg: '',
                uploadDialog: false
            };
        },
        created() {
            this.DataList()
        },
        mounted() {

        },
        filters: {
            /**
             * @param {
             *
             * }
             */
            statusFilter(status) {
                if (status == 1) {
                    return "启用";
                } else if (status == 2) {
                    return "禁用";
                }
            },
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
            },

        },
        methods: {

            handelCancel(row){
                this.$confirm('请是否确认退保?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback: (action) => {
                        if (action === 'confirm') {
                            // const val = this.checkedDetail
                            // val.forEach((val, index) => {
                            //     this.tableData.forEach((v, i) => {
                            //         if (val.xh === v.xh) {
                            //             this.tableData.splice(i, 1)
                            //         }
                            //     })
                            // })
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.$refs.tb.clearSelection()
                            return
                        } else {
                            this.$message({
                                message: '已取消操作',
                                type: 'warning'
                            })
                            return
                        }
                    }
                })
            },
            //接收子组件传过来的值
            chooseCarInfo(car_number,...params){
                this.searchForm.name=car_number;

            },
            DataList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    page: this.page,
                }
                this.$axios.OrderProductSqlList(param).then(res=>{
                    if(res.code == 200){
                        this.tableLoadData = res.data.data
                        this.total = res.data.total
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.limit = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.page = newPage
                this.DataList()
            },
            // 新增
            addData() {
                // this.isShowCar=true;
                // //console.log('dddd',this.isShowCar)
                this.$router.push('/insuranceTeamOrder')
            },
            handelEdit(index,row) {
                this.id = index.id

                this.title = '编辑'
                this.form = {
                }
                this.dialogFormVisible = true
                // this.form = {...row};
                // 或者
                this.form = JSON.parse(JSON.stringify(index))
            },

            reset_dialogForm(formName) {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs[formName].resetFields()
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(!this.id){
                            const param = {
                                name: this.form.name,
                                address: this.form.address,
                                credit_code: this.form.credit_code,
                                composition: this.form.composition,
                                business_scope: this.form.business_scope,
                                incorporation_date: this.form.incorporation_date,
                                corporation: this.form.corporation,
                                registered_capital: this.form.registered_capital,
                                certificate_no: this.form.certificate_no,
                                lifespan: this.form.lifespan,
                                issue_date: this.form.issue_date,
                                type: this.form.type,
                                duty_paragraph: this.form.duty_paragraph,
                                mobile: this.form.mobile,
                                bank: this.form.bank,
                                bank_account: this.form.bank_account,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id:sessionStorage.getItem('company_id'),
                                access_token:sessionStorage.getItem('token')
                            }
                            this.$axios.shopShopSave(param).then(res =>{
                                if(res.code == 200){
                                    this.DataList()
                                    this.$message.success(res.msg)
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }else{
                            const param = {
                                id: this.form.id,
                                name: this.form.name,
                                address: this.form.address,
                                credit_code: this.form.credit_code,
                                composition: this.form.composition,
                                business_scope: this.form.business_scope,
                                incorporation_date: this.form.incorporation_date,
                                corporation: this.form.corporation,
                                registered_capital: this.form.registered_capital,
                                certificate_no: this.form.certificate_no,
                                lifespan: this.form.lifespan,
                                issue_date: this.form.issue_date,
                                type: this.form.type,
                                duty_paragraph: this.form.duty_paragraph,
                                mobile: this.form.mobile,
                                bank: this.form.bank,
                                bank_account: this.form.bank_account,
                                operator_id: sessionStorage.getItem('user_id'),
                                company_id:sessionStorage.getItem('company_id'),
                                access_token:sessionStorage.getItem('token')
                            }
                            this.$axios.shopShopSave(param).then(res =>{
                                if(res.code == 200){
                                    this.$message.success(res.msg)
                                    this.DataList()
                                    this.dialogFormVisible = false
                                }else{
                                    this.$message.error(res.msg);
                                }
                            })
                        }

                    }
                })
            },
            searchSubmit() {
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    queryParams: this.searchForm.name,
                    credit_code: this.searchForm.credit_code,
                    page: this.page,
                }
                this.$refs.searchForRef.validate((valid) => {
                    if (valid) {
                        this.$axios.shopShopList(param).then(res=>{
                            if(res.code == 200){
                                this.tableLoadData = res.data.data
                                this.total = res.data.total
                            }
                        })
                    }
                })
            },

            handelDel(e) {
                this.$confirm('此操作将删除该运输公司, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const param = {
                        company_id:sessionStorage.getItem('company_id'),
                        access_token:sessionStorage.getItem('token'),
                        id: e.id,
                    }
                    //console.log(param);
                    this.$axios.shopShopDel(param).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.DataList()
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error=>{
                        //console.log(error);
                    })
                }).catch(() => {
                    // 点击取消:不删除了
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                    this.DataList()
                });
                this.teamDialog = false
            },
            // 点击弹出当前的图片
            handelDialog(index) {
                this.uploadDialog = true
                this.uploadImg = index.row.file_url.local_file_path
            }

        },
    };
</script>
<style>
    .table_name{
        font-weight: bold;
        /* border: 1px solid #f00; */
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/insurance/insuranceOrderList.vue